import { createFlags } from 'flag'
import config from '@/config'
const isDev = config.BUILD_ENV === 'dev'

type Flags = {
  features: {
    pad: boolean
    blocks: boolean
    chat: {
      menu: boolean
    }
    application: {
      create: boolean
    }
    contract: {
      renew: boolean
    }
    payments: boolean
    listing: {
      ads: boolean
      insights: boolean
      impressions: boolean
    }
    manage: boolean
    profile: {
      tenant: boolean
      landlord: boolean
    }
    pricing: {
      taxCode: boolean
    }
    support: boolean
    sharp: boolean
    translations: {
      french: boolean
    }
    toaster: boolean
  }
}

const flags: Flags = {
  features: {
    pad: true,
    blocks: true,
    chat: {
      menu: true
    },
    application: {
      create: true
    },
    contract: {
      renew: true
    },
    payments: true,
    listing: {
      ads: isDev,
      insights: true,
      impressions: true
    },
    manage: true,
    profile: {
      tenant: true,
      landlord: true
    },
    pricing: {
      taxCode: false
    },
    support: true,
    sharp: false,
    translations: {
      french: true
    },
    toaster: true
  }
}
const { FlagBackendProvider: FlagsProvider, Flag, useFlag } = createFlags<Flags>()

export { FlagsProvider, Flag, useFlag, flags }
